module.exports = __webpack_public_path__ + "img/m.267b1451.jpg";